/**
 * useSimplifiedNav — retired. V1 (2026-09-25): Rennan killed the
 * six-destination "simplified" bar / rail. Every chrome shows the
 * full list; there is no toggle. The hook keeps its shape so the
 * consumers that still branch on it compile — they always take the
 * classic path — and the stored preference is ignored.
 */
export function useSimplifiedNav(): [boolean, (next: boolean) => void] {
  return [false, () => undefined];
}
